// The native side reports the same two statuses whatever failed: "retryable" for anything
// transient, "unavailable" for anything final. Feeding both into one set of messages told a
// reader whose prices had merely failed to load that their purchase could not be confirmed —
// a purchase they had never started. These decide what a products failure actually means.

// Prices sit on "Loading…" until products arrive and there is no button to press, so a
// transient failure is worth one silent retry before admitting defeat.
export function productsFailure(status, { retried = false } = {}) {
  if (status === "retryable" && !retried) return { action: "retry" }

  return {
    action: "show",
    messageKey: status === "retryable" ? "products_retryable" : "products_unavailable"
  }
}
